import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ProspectosCreate from "./ProspectosCreate";
import ArchivosProspecto from "./ArchivosProspecto";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
  ButtonGroup,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import ESTADOS_MEXICO from "../estadosMexico";
import { puedeCrm } from "../permisosCrm";
import { etiquetasEtapas, nombreEtapa } from "../etapas";
import { lineasActivas, COLOR_LINEA } from "../lineas";
import { SECTORES, sectorDe, BadgeSector, pasaFiltroSector, OpcionesFiltroSector } from "../sectores";
import { pdfCrm, excelCrm, dineroCrm, textoFiltroSector } from "../exportaCrm";

// Filtro de seleccion multiple: buscador + lista con checkboxes; lo marcado se ve como badges.
// opciones: [{ _id, etiqueta, extra?, color? }]
function FiltroMulti({ opciones, seleccion, onChange, placeholder, nombre, maximo = 60 }) {
  const [buscar, setBuscar] = useState("");
  const [abierto, setAbierto] = useState(false);

  const toggle = (id) =>
    onChange(seleccion.includes(id) ? seleccion.filter((x) => x !== id) : [...seleccion, id]);

  const visibles = opciones
    .filter((o) => {
      if (!buscar) return true;
      const t = buscar.toLowerCase();
      return (o.etiqueta || "").toLowerCase().includes(t) || (o.extra || "").toString().toLowerCase().includes(t);
    })
    .slice(0, maximo);

  return (
    <>
      <div style={{ position: "relative" }}>
        <Input
          type="text"
          placeholder={seleccion.length ? `${seleccion.length} ${nombre}(s) seleccionado(s)` : placeholder}
          value={buscar}
          onChange={(e) => {
            setBuscar(e.target.value);
            setAbierto(true);
          }}
          onFocus={() => setAbierto(true)}
        />
        {abierto && (
          <div
            style={{
              position: "absolute",
              zIndex: 20,
              top: "100%",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1px solid #e2e8f0",
              borderRadius: 6,
              boxShadow: "0 6px 16px rgba(0,0,0,.12)",
              maxHeight: 280,
              overflowY: "auto",
              padding: 6,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", padding: "2px 4px 6px" }}>
              <small className="text-muted">
                {visibles.length === maximo ? `Mostrando ${maximo}, afina la búsqueda` : `${visibles.length} ${nombre}(s)`}
              </small>
              <div>
                {seleccion.length > 0 && (
                  <Button size="sm" color="link" style={{ padding: "0 6px" }} onClick={() => onChange([])}>
                    Limpiar
                  </Button>
                )}
                <Button size="sm" color="link" style={{ padding: "0 6px" }} onClick={() => setAbierto(false)}>
                  Cerrar
                </Button>
              </div>
            </div>
            {visibles.map((o) => (
              <label
                key={o._id}
                style={{ display: "flex", alignItems: "center", gap: 8, padding: "3px 4px", margin: 0, cursor: "pointer" }}
              >
                <input
                  type="checkbox"
                  checked={seleccion.includes(o._id)}
                  onChange={() => toggle(o._id)}
                  style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                />
                <span>{o.etiqueta}</span>
                {o.extra ? <small className="text-muted">{o.extra}</small> : null}
              </label>
            ))}
          </div>
        )}
      </div>
      {seleccion.length > 0 && (
        <div style={{ marginTop: 4 }}>
          {seleccion.map((id) => {
            const o = opciones.find((x) => x._id === id);
            return (
              <span
                key={id}
                className="badge"
                style={{
                  backgroundColor: (o && o.color) || "#e2e8f0",
                  color: o && o.color ? "#fff" : "#334155",
                  marginRight: 3,
                  marginBottom: 2,
                  display: "inline-block",
                  cursor: "pointer",
                }}
                title="Quitar del filtro"
                onClick={() => toggle(id)}
              >
                {o ? o.etiqueta : id} &times;
              </span>
            );
          })}
        </div>
      )}
    </>
  );
}

function ListadoProspectos() {
  const { user } = useContext(AuthContext);
  const URL_CRM_PROSPECTOS = process.env.REACT_APP_URL_CRM_PROSPECTOS;
  const URL_LINEAS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  const URL_CRM_OPORTUNIDADES = process.env.REACT_APP_URL_CRM_OPORTUNIDADES;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [prospectos, setProspectos] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [search, setSearch] = useState("");
  const [filtroLineas, setFiltroLineas] = useState([]);
  const [filtroSector, setFiltroSector] = useState("");
  const [filtroProductos, setFiltroProductos] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const etiquetaEtapa = etiquetasEtapas(etapas);

  const [modalCreate, setModalCreate] = useState(false);
  const toggleCreate = () => setModalCreate(!modalCreate);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  // Modal de oportunidades del prospecto
  const [modalOp, setModalOp] = useState(false);
  const toggleOp = () => setModalOp(!modalOp);
  const [oportunidades, setOportunidades] = useState([]);
  const [prospectoSel, setProspectoSel] = useState("");
  const [prospectoIdSel, setProspectoIdSel] = useState("");

  const [idEdit, setIdEdit] = useState();
  const [razon_social, setRazonSocial] = useState("");
  const [contacto, setContacto] = useState("");
  const [cargo, setCargo] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [RFC, setRFC] = useState("");
  const [origen, setOrigen] = useState("");
  const [estado, setEstado] = useState("");
  const [sector, setSector] = useState("");
  const [lineasSel, setLineasSel] = useState([]);
  const [articulosSel, setArticulosSel] = useState([]);
  const [buscarArticulo, setBuscarArticulo] = useState("");
  const [notas, setNotas] = useState("");
  const [usuarios, setUsuarios] = useState([]);
  const [responsable, setResponsable] = useState("");
  const [valor_estimado, setValorEstimado] = useState(0);
  const [opId, setOpId] = useState("");

  useEffect(() => {
    getProspectos();
    const h = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(URL_LINEAS, h).then((r) => setLineas(lineasActivas(r.data))).catch((e) => console.log(e));
    axios.get(URL_COLABORADORES, h).then((r) => setUsuarios(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_ARTICULOS, h).then((r) => setArticulos(r.data)).catch((e) => console.log(e));
    axios.get(process.env.REACT_APP_URL_CRM_ETAPAS, h).then((r) => setEtapas(r.data)).catch((e) => console.log(e));
  }, []);

  function toggleLinea(id) {
    setLineasSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  // Activos + los ya seleccionados, filtrados por el buscador (codigo o descripcion).
  const articulosFiltrados = articulos
    .filter((a) => a.is_active === "Si" || articulosSel.includes(a._id))
    .filter((a) => {
      if (!buscarArticulo) return true;
      const s = buscarArticulo.toLowerCase();
      return (
        (a.descripcion || "").toLowerCase().includes(s) ||
        (a.codigo || "").toString().toLowerCase().includes(s)
      );
    })
    .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1));

  function toggleArticulo(id) {
    setArticulosSel((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  // Opciones de los filtros multi (productos: activos + los ya marcados).
  const opcionesProductosFiltro = articulos
    .filter((a) => a.is_active === "Si" || filtroProductos.includes(a._id))
    .sort((a, b) => (a.descripcion > b.descripcion ? 1 : -1))
    .map((a) => ({ _id: a._id, etiqueta: a.descripcion || a.codigo, extra: a.codigo }));
  // las líneas ya vienen activas y en orden (lineasActivas)
  const opcionesLineasFiltro = lineas.map((c) => ({
    _id: c._id,
    etiqueta: c.name,
    color: COLOR_LINEA,
  }));

  function getProspectos() {
    axios
      .get(URL_CRM_PROSPECTOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setProspectos(response.data))
      .catch((err) => console.log(err));
  }

  function jalaInfo(a) {
    setIdEdit(a._id);
    setRazonSocial(a.razon_social);
    setContacto(a.contacto || "");
    setCargo(a.cargo || "");
    setEmail(a.email || "");
    setTelefono(a.telefono || "");
    setWhatsapp(a.whatsapp || "");
    setEmpresa(a.empresa || "");
    setRFC(a.RFC || "");
    setOrigen(a.origen || "");
    setEstado(a.estado || "");
    setSector(sectorDe(a));
    setLineasSel((a.lineas || []).map((c) => (c._id ? c._id : c)));
    setArticulosSel((a.articulosInteres || []).map((x) => (x._id ? x._id : x)));
    setBuscarArticulo("");
    setNotas(a.notas || "");
    // Precarga responsable/valor desde la oportunidad del prospecto.
    setResponsable("");
    setValorEstimado(0);
    setOpId("");
    axios
      .get(`${URL_CRM_PROSPECTOS}/${a._id}/oportunidades`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => {
        const op = (r.data || [])[0];
        if (op) {
          setOpId(op._id);
          setResponsable(op.responsable ? (op.responsable._id || op.responsable) : "");
          setValorEstimado(op.valor_estimado || 0);
        }
      })
      .catch((e) => console.log(e));
    toggle();
  }

  function editProspecto(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_CRM_PROSPECTOS}/${idEdit}`,
        { razon_social, contacto, cargo, email, telefono, whatsapp, empresa, RFC, origen, estado, sector, lineas: lineasSel, articulosInteres: articulosSel, notas },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Prospecto", detalle: razon_social, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        // (2026-10) sin recargar la página: se cierra y se refresca la lista
        const finalizar = () => {
          setModal(false);
          Swal.fire("Good job!", "Actualizado con exito", "success");
          getProspectos();
        };
        // Actualiza responsable/valor en la oportunidad del prospecto.
        if (opId) {
          axios
            .patch(
              `${URL_CRM_OPORTUNIDADES}/${opId}`,
              { responsable, valor_estimado: Number(valor_estimado) || 0 },
              { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
            )
            .then(finalizar)
            .catch(finalizar);
        } else {
          finalizar();
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  }

  function cargaOportunidadesDe(id) {
    return axios
      .get(`${URL_CRM_PROSPECTOS}/${id}/oportunidades`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((response) => setOportunidades(response.data));
  }

  function verOportunidades(a) {
    setProspectoSel(a.razon_social);
    setProspectoIdSel(a._id);
    cargaOportunidadesDe(a._id)
      .then(() => setModalOp(true))
      .catch((err) => console.log(err));
  }

  // (2026-10) Prospecto que se quedó sin oportunidad (se dio de alta cuando aún
  // no había etapas): se le crea en la primera etapa para poder moverla.
  function crearOportunidad() {
    axios
      .post(
        `${URL_CRM_PROSPECTOS}/${prospectoIdSel}/oportunidad`,
        {
          fecha: new Date().toISOString().split("T")[0],
          usuarioNombre: user.nombre,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        Swal.fire(
          "Listo",
          "Oportunidad creada. Muévela de etapa en CRM → Oportunidades o en el Embudo de Ventas.",
          "success"
        );
        cargaOportunidadesDe(prospectoIdSel);
        getProspectos();
        axios
          .get(process.env.REACT_APP_URL_CRM_ETAPAS, {
            headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
          })
          .then((r) => setEtapas(r.data))
          .catch((e) => console.log(e));
      })
      .catch((error) =>
        Swal.fire({
          icon: "error",
          title: "No se pudo crear la oportunidad",
          text: error.response?.data?.message || String(error),
        })
      );
  }

  const prospectosFiltrados = prospectos.filter((a) => {
    // La busqueda tambien pega contra los productos de interes.
    const productos = (a.articulosInteres || [])
      .map((p) => `${p.codigo || ""} ${p.descripcion || ""}`)
      .join(" ");
    const t = `${a.razon_social} ${a.empresa} ${a.contacto} ${a.email} ${a.telefono} ${sectorDe(a)} ${productos}`.toLowerCase();
    if (!t.includes(search.toLowerCase())) return false;
    if (!pasaFiltroSector(a, filtroSector)) return false;
    if (
      filtroLineas.length &&
      !(a.lineas || []).some((c) => filtroLineas.includes(c._id || c))
    )
      return false;
    if (
      filtroProductos.length &&
      !(a.articulosInteres || []).some((p) => filtroProductos.includes(p._id || p))
    )
      return false;
    return true;
  });

  // (2026-10) PDF / Excel de lo filtrado (sector, líneas, productos, búsqueda)
  const filtrosProspectos = () =>
    [
      `Sector: ${textoFiltroSector(filtroSector)}`,
      filtroLineas.length
        ? `Líneas: ${lineas.filter((l) => filtroLineas.includes(l._id)).map((l) => l.name).join(", ")}`
        : "Todas las líneas",
      filtroProductos.length ? `${filtroProductos.length} producto(s) de interés` : "",
      search ? `Búsqueda: "${search}"` : "",
    ]
      .filter((t) => t)
      .join("   ·   ");
  const filaProspecto = (a) => [
    a.idProspecto,
    a.razon_social,
    sectorDe(a) || "Sin sector",
    a.contacto || "",
    a.telefono || "",
    a.email || "",
    a.estado && a.estado !== "NA" ? a.estado : "",
    (a.lineas || []).map((l) => l.name).join(", "),
    (a.articulosInteres || []).map((p) => p.descripcion || p.codigo).join(", "),
    a.origen || "",
  ];
  const COLS_PROSPECTOS = ["Folio", "Nombre / Razón social", "Sector", "Contacto", "Teléfono", "Email", "Estado", "Líneas", "Productos de interés", "Origen", "Valor"];
  const archivoProspectos = () =>
    `Prospectos${filtroSector ? ` - ${textoFiltroSector(filtroSector)}` : ""}`;

  function pdfProspectos() {
    pdfCrm({
      titulo: "Prospectos",
      filtros: filtrosProspectos(),
      archivo: archivoProspectos(),
      columnas: [
        { titulo: "Folio", ancho: 12, alinear: "center" },
        { titulo: "Nombre / Razón social", ancho: 42 },
        { titulo: "Sector", ancho: 17, alinear: "center" },
        { titulo: "Contacto", ancho: 30 },
        { titulo: "Teléfono", ancho: 22 },
        { titulo: "Email", ancho: 36 },
        { titulo: "Estado", ancho: 22 },
        { titulo: "Líneas", ancho: 30 },
        { titulo: "Productos de interés" },
        { titulo: "Origen", ancho: 18 },
        { titulo: "Valor", ancho: 20, alinear: "right" },
      ],
      filas: prospectosFiltrados.map((a) => [...filaProspecto(a), dineroCrm(a.valor_estimado)]),
    });
  }

  function excelProspectos() {
    excelCrm({
      archivo: archivoProspectos(),
      hojas: [
        {
          nombre: "Prospectos",
          columnas: COLS_PROSPECTOS,
          filas: prospectosFiltrados.map((a) => [...filaProspecto(a), Number(a.valor_estimado || 0)]),
        },
      ],
    });
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puedeCrm(user, "crm.prospectos.ver") ? (
          <div className="card col-12">
            <Row>
              <Col md={8}>
                {puedeCrm(user, "crm.prospectos.crear") && (
                  <Button size="sm" color="success" onClick={toggleCreate}>
                    Nuevo Prospecto
                  </Button>
                )}
              
                <Button size="sm" href="/MenuCrm" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
              </Col>
              <Col sm={4}>
                <ButtonGroup id="logoutBoton">
                  <Button size="sm" className="btn" color="danger" onClick={pdfProspectos}>
                    PDF <i className="far fa-file-pdf"></i>
                  </Button>
                  <Button size="sm" className="btn" color="primary" onClick={excelProspectos}>
                    Excel <i className="far fa-file-excel"></i>
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
            <h3 align="center">Prospectos</h3>
            <Row>
              <Col md={3}>
                <Input
                  type="text"
                  placeholder="Buscar..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Col>
              <Col md={2}>
                <Input type="select" value={filtroSector} onChange={(e) => setFiltroSector(e.target.value)}>
                  <OpcionesFiltroSector />
                </Input>
              </Col>
              <Col md={3}>
                <FiltroMulti
                  opciones={opcionesLineasFiltro}
                  seleccion={filtroLineas}
                  onChange={setFiltroLineas}
                  placeholder="Filtrar por línea..."
                  nombre="línea"
                />
              </Col>
              <Col md={4}>
                <FiltroMulti
                  opciones={opcionesProductosFiltro}
                  seleccion={filtroProductos}
                  onChange={setFiltroProductos}
                  placeholder="Filtrar por producto de interés..."
                  nombre="producto"
                />
              </Col>
            </Row>
            <br />
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla">Nombre / Razon social</th>
                  <th className="tituloTabla">Sector</th>
                  {/* <th className="tituloTabla">Empresa</th> */}
                  <th className="tituloTabla">Contacto</th>
                  <th className="tituloTabla">Telefono</th>
                  <th className="tituloTabla">Estado</th>
                  <th className="tituloTabla">Líneas</th>
                  <th className="tituloTabla">Productos de interés</th>
                  <th className="tituloTabla">Origen</th>
                  <th className="tituloTabla">Valor</th>
                  <th className="tituloTabla">Oportunidades</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {prospectosFiltrados.map((a) => (
                  <tr key={a._id}>
                    <td>{a.idProspecto}</td>
                    <td>{a.razon_social}</td>
                    <td><BadgeSector prospecto={a} /></td>
                    {/* <td>{a.empresa}</td> */}
                    <td>{a.contacto}</td>
                    <td>{a.telefono}</td>
                    <td>{a.estado}</td>
                    <td>
                      {(a.lineas || []).map((c) => (
                        <span
                          key={c._id}
                          className="badge"
                          style={{ backgroundColor: COLOR_LINEA, color: "#fff", marginRight: 3 }}
                        >
                          {c.name}
                        </span>
                      ))}
                    </td>
                    <td style={{ minWidth: 220 }}>
                      {(a.articulosInteres || []).length === 0 ? (
                        <span className="text-muted">-</span>
                      ) : (
                        (a.articulosInteres || []).map((p) => (
                          <span
                            key={p._id}
                            className="badge"
                            style={{
                              backgroundColor: "#e2e8f0",
                              color: "#334155",
                              marginRight: 3,
                              marginBottom: 2,
                              display: "inline-block",
                            }}
                            title={`${p.codigo || ""} ${p.descripcion || ""}`.trim()}
                          >
                            {p.descripcion || p.codigo}
                          </span>
                        ))
                      )}
                    </td>
                    <td>{a.origen}</td>
                    <td align="right" style={{ whiteSpace: "nowrap" }}>
                      ${Number(a.valor_estimado || 0).toLocaleString("es-MX")}
                    </td>
                    <td>
                      <Button color="primary" size="sm" onClick={() => verOportunidades(a)}>
                        <i className="fas fa-handshake"></i>
                      </Button>
                      {/* (2026-10) cotizar al prospecto (si ya es cliente se cotiza como cliente) */}
                      {!a.cliente ? (
                        <Button
                          color="success"
                          size="sm"
                          title="Hacer cotización"
                          href={`/CotizacionesCreate?prospecto=${a._id}`}
                        >
                          <i className="fas fa-file-invoice-dollar"></i>
                        </Button>
                      ) : null}
                    </td>
                    <td>
                      {puedeCrm(user, "crm.prospectos.editar") && (
<Button color="info" size="sm" onClick={() => jalaInfo(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      {/* Alta */}
      <Modal size="lg" isOpen={modalCreate} toggle={toggleCreate}>
        <ModalHeader toggle={toggleCreate}>
          Nuevo Prospecto
        </ModalHeader>
        <ModalBody>
          <ProspectosCreate
            onSaved={() => {
              setModalCreate(false);
              getProspectos();
            }}
          />
        </ModalBody>
      </Modal>

      {/* Edicion */}
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          Editar Prospecto
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Nombre / Razon social</Label>
              <Input type="text" value={razon_social} onChange={(e) => setRazonSocial(e.target.value)} />
            </Col>
            <Col md={3}>
              <Label>Estado (República)</Label>
              <Input type="select" value={estado} onChange={(e) => setEstado(e.target.value)}>
                <option value="">Selecciona...</option>
                {ESTADOS_MEXICO.map((es) => (
                  <option key={es} value={es}>{es}</option>
                ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Sector</Label>
              <Input type="select" value={sector} onChange={(e) => setSector(e.target.value)}>
                <option value="">Selecciona...</option>
                {SECTORES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Persona de contacto</Label>
              <Input type="text" value={contacto} onChange={(e) => setContacto(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Cargo</Label>
              <Input type="text" value={cargo} onChange={(e) => setCargo(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Telefono</Label>
              <Input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>WhatsApp</Label>
              <Input type="text" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>RFC</Label>
              <Input type="text" value={RFC} onChange={(e) => setRFC(e.target.value)} />
            </Col>
            <Col md={6}>
              <Label>Origen del lead</Label>
              <Input type="select" value={origen} onChange={(e) => setOrigen(e.target.value)}>
                <option value="Web">Web</option>
                <option value="Referido">Referido</option>
                <option value="Llamada en frio">Llamada en frio</option>
                <option value="Feria">Feria / Expo</option>
                <option value="Recuperacion de Cliente">Recuperacion de Cliente</option>
                <option value="Redes sociales">Redes sociales</option>
                <option value="Recomendacion">Recomendacion</option>
                <option value="ClienteActual">Cliente Actual</option>
                <option value="Otro">Otro</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Responsable</Label>
              <Input type="select" value={responsable} onChange={(e) => setResponsable(e.target.value)}>
                <option value="">Sin asignar</option>
                {usuarios.map((u) => (
                  <option key={u._id} value={u._id}>{u.nombre} {u.apellido}</option>
                ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Valor estimado</Label>
              <Input
                type="number"
                value={valor_estimado}
                onChange={(e) => setValorEstimado(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Label>Líneas</Label>
              {/* En columnas para que quepan todas sin scroll. */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))",
                  gap: "2px 12px",
                  border: "1px solid #e2e8f0",
                  borderRadius: 6,
                  padding: 8,
                }}
              >
                {lineas.length === 0 ? (
                  <small className="text-muted">Sin líneas.</small>
                ) : (
                  lineas.map((c) => (
                    <div key={c._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={lineasSel.includes(c._id)}
                        onChange={() => toggleLinea(c._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{c.name}</span>
                    </div>
                  ))
                )}
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={12}>
              <Label>Artículos de interés (opcional)</Label>
              <Input
                type="text"
                placeholder="Buscar artículo..."
                value={buscarArticulo}
                onChange={(e) => setBuscarArticulo(e.target.value)}
                style={{ marginBottom: 8 }}
              />
              <div style={{ height: 240, overflowY: "auto", border: "1px solid #e2e8f0", borderRadius: 6, padding: 8 }}>
                {articulosFiltrados.length === 0 ? (
                  <small className="text-muted">Sin artículos que coincidan.</small>
                ) : (
                  articulosFiltrados.map((a) => (
                    <div key={a._id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "2px 0" }}>
                      <input
                        type="checkbox"
                        checked={articulosSel.includes(a._id)}
                        onChange={() => toggleArticulo(a._id)}
                        style={{ width: 15, height: 15, margin: 0, flexShrink: 0 }}
                      />
                      <span>{a.codigo ? `${a.codigo} / ` : ""}{a.descripcion}</span>
                    </div>
                  ))
                )}
              </div>
              {articulosSel.length > 0 && (
                <small className="text-muted">{articulosSel.length} artículo(s) seleccionado(s)</small>
              )}
            </Col>
          </Row>
          <br />
          <Label>Notas</Label>
          <Input type="textarea" value={notas} onChange={(e) => setNotas(e.target.value)} />
          <br />
          {/* (2026-10) archivos del prospecto (se guardan al subirlos) */}
          <ArchivosProspecto idProspecto={idEdit} puedeEditar={puedeCrm(user, "crm.prospectos.editar")} />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editProspecto}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Oportunidades del prospecto */}
      <Modal size="lg" isOpen={modalOp} toggle={toggleOp}>
        <ModalHeader toggle={toggleOp}>
          Oportunidades de {prospectoSel}
        </ModalHeader>
        <ModalBody>
          {oportunidades.length === 0 ? (
            <>
              <p>Sin oportunidades registradas.</p>
              {puedeCrm(user, "crm.prospectos.crear") && (
                <Button size="sm" color="success" onClick={crearOportunidad}>
                  Crear oportunidad
                </Button>
              )}
            </>
          ) : (
            <Table size="sm" striped borderless>
              <thead>
                <tr>
                  <th>Folio</th>
                  <th>Titulo</th>
                  <th>Etapa</th>
                  <th>Valor</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                {oportunidades.map((o) => (
                  <tr key={o._id}>
                    <td>{o.idOportunidad}</td>
                    <td>{o.titulo}</td>
                    <td>{nombreEtapa(etiquetaEtapa, o.etapa) || "-"}</td>
                    <td>${Number(o.valor_estimado || 0).toLocaleString("es-MX")}</td>
                    <td>{o.estado}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

export default ListadoProspectos;
